import React from 'react';

interface BudgetIconOneProps {
  width?: number;
  height?: number;
  strokeColor?: string;
}

const BudgetIconOne: React.FC<BudgetIconOneProps> = ({ width = 50, height = 50, strokeColor = '#495057' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="7.5" cy="7.5" r="7.5" fill={strokeColor} />
      <circle cx="40" cy="10" r="10" fill={strokeColor} />
      <circle cx="42.5" cy="42.5" r="7.5" fill={strokeColor} />
      <circle cx="15" cy="35" r="15" fill={strokeColor} />
    </svg>
  );
};

export default BudgetIconOne;
